<aza-rws-multi-registration-form
    *ngIf="uiState && config && allParticipantFields"
    [controller]="multiRegistrationSvc.controller"
    [state]="uiState"
    [allParticipantFields]="allParticipantFields"
    [subParticipantFieldIds]="config?.subparticipant_form_field_ids"
    [eventParticipant]="eventParticipant"
    [config]="config"
    [eventSettings]="eventSettings"
></aza-rws-multi-registration-form>
